<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>

    <section class="search-bar">
      <el-select
        v-model="dataTypeVal"
        size="small"
        style="width:130px;"
        @change="onDataTypeValChanged"
      >
        <el-option
          v-for="dataType in dataTypes"
          :key="dataType.value"
          :value="dataType.value"
          :label="dataType.label"
        />
      </el-select>

      <data-time-query :query="query" />

      <span v-if="currentDataType.showCompareTime" style="font-size:14px;line-height:32px;color:rgb(96,98,102);">对比时间:</span>
      <data-time-query v-if="currentDataType.showCompareTime" :query="compareQuery" :clearable="true" />

      <site-query :sites="filterSites" :query="query" />

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="onSearchBtnClick"
      >查询</el-button>
    </section>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />
      </template>

      <component
        ref="dataRenderer"
        :is="currentDataType.component.name"
        :query="currentQuery"
        :compare-query="currentCompareQuery"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteDeviceData from '../../../BaseSiteDeviceData'
import {DATA_TYPE_MAP, DATA_TYPES, FACTOR_OPTS} from './constants'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'

export default {
  name: 'PollutantCompare',
  routeInfo: {
    label: '颗粒物组分污染分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteDeviceData,
  components: DATA_TYPES.reduce((components, DATA_TYPE) => {
    let component = DATA_TYPE.component
    components[component.name] = component
    return components
  }, {
    LayoutContent,
    DataTimeQuery,
    SiteQuery,
    CompletedQuery,
    DataWrapper
  }),
  data: () => ({
    query: {
      isFuse: false,
      isGetInvalidData: true,
      isMultipleIntegral: true,
      factorIds: Object.freeze(FACTOR_OPTS.reduce((list, factorOpt) => {
        if (factorOpt.query) {
          list.push(factorOpt.id)
        }

        return list
      }, []))
    },
    compareQuery: {
      beginTime: '',
      endTime: ''
    },
    currentCompareQuery: Object.freeze({}),
    unitProp: 'displayUnit',
    dataTypeVal: DATA_TYPES[0].value
  }),
  computed: {
    queryTimeStep: () => 7,
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, true),
      new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
    ],
    minSiteSelectNumber: () => 3,
    dataTypes: () => DATA_TYPES,
    currentDataType () {
      return DATA_TYPE_MAP[this.dataTypeVal]
    }
  },
  methods: {
    setCurrentQuery () {
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
      this.currentCompareQuery = Object.freeze(JSON.parse(JSON.stringify(this.compareQuery)))
    },
    getData () {
      this.$nextTick(() => {
        this.$refs.dataRenderer.getData()
      })
    },
    onDataTypeValChanged () {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  gap: 6px;
  float: left;
  margin-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/02Pollutant/index.vue